"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M20 6a2 2 0 0 1-2.187 1.991l-2.68 5.36a2 2 0 1 1-2.802.546l-1.413-2.12a2 2 0 0 1-1.128.212l-2.63 4.382a2 2 0 1 1-.95-.36l2.63-4.382a2 2 0 1 1 2.83-.527l1.413 2.12a2 2 0 0 1 1.104-.213l2.68-5.36A2 2 0 1 1 20 6m-2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-8 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-4 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2m9-4a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
}), 'Sales');
//# sourceMappingURL=index.js.map